export const VOTE_MAP = {
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
};
